import Button from "components/Button";
import { buttonType } from "components/Button/Button";
import { ErrorMessage, SubmitButton } from "features/payment/paymentPageStyles";
import React from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText, shadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { Link } from "react-router-dom";
import { fastOrder } from "features/payment/paymentSlice";
import { Accessory } from "features/accessories/types";
import { useDispatch } from "react-redux";
import { Product } from "features/ProductReel/types";
import { MessageType } from "features/message/types";
import { setMessage } from "features/message/messageSlice";

interface FastOrderProps {
  item: Accessory | Product;
}

const FastOrder: React.FC<FastOrderProps> = ({ item }) => {
  const { register, handleSubmit, errors, reset } = useForm();
  const dispatch = useDispatch();

  const onFormSubmit = async (data: any) => {
    if (!data.emailFake) {
      dispatch(
        fastOrder({
          ...data,
          item: {
            alias: item.alias,
            title: item.title,
            objectType: item.objectType,
          },
        })
      );

      reset();
    }
  };

  return (
    <FastOrderContainer>
      <h3>Бърза поръчка</h3>
      <Actions onSubmit={handleSubmit(onFormSubmit)}>
        <InputContainer>
          <Input
            className="text-body"
            name="names"
            ref={register({ minLength: 10 })}
            placeholder="Вашите имена"
            required={true}
          />

          {errors.names && errors.names?.type === "minLength" && (
            <ErrorMessage>Дължината трябва да бъде до 10 символа.</ErrorMessage>
          )}
        </InputContainer>
        <InputContainer>
          <Input
            className="text-body"
            name="number"
            ref={register({ minLength: 10, maxLength: 20 })}
            placeholder="Телефонен номер"
            required={true}
          />

          {errors.names && errors.names?.type === "minLength" && (
            <ErrorMessage>Дължината трябва да 10 символа.</ErrorMessage>
          )}
        </InputContainer>
        <Input
          className="text-body"
          name="emailFake"
          style={{ display: "none" }}
        />
        <SubmitButton
          className="submit-button text-md"
          type="submit"
          value="Поръчай"
        />
      </Actions>
      <LowerSection>
        <InfoText className="text-sm">
          * Наш служител ще се свърже с Вас{" "}
          <strong>до края на работния ден</strong>
        </InfoText>
        <InfoText className="text-sm">
          С изпращането на тази форма Вие се съгласявате личните Ви данни да
          бъдат обработвани в съответствие с{" "}
          <NavLink to={"/terms-and-conditions"}>
            Политика за обработване на личните данни
          </NavLink>
        </InfoText>
      </LowerSection>
    </FastOrderContainer>
  );
};

const NavLink = styled(Link)``;

const FastOrderContainer = styled.div`
  ${shadow}
  background-color: ${colors.gray};
  padding: 20px;
  margin: 20px 0;

  @media only screen and (${device.laptop}) {
    margin: 20px 20px;
  }
`;
FastOrderContainer.displayName = "FastOrderContainer";

const Actions = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;

  .order-button {
    padding: 10px;
  }

  @media only screen and (${device.laptop}) {
    grid-template-columns: 2fr 2fr 1fr;
    grid-template-rows: 1;
    grid-column-gap: 20px;
    align-items: center;
  }
`;

const InputContainer = styled.div`
  width: 100%;

  & + & {
    margin: 10px 0;
  }
`;
InputContainer.displayName = "InputContainer";

const Input = styled.input`
  width: 100%;
  border-width: 0;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
`;

const LowerSection = styled.div`
  margin: 10px 0;
`;

const InfoText = styled(DefaultText)`
  width: 100%;

  & + & {
    margin: 5px 0;
  }
`;

export default FastOrder;
